import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarEventService {
  private isMonthClicked$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private closeDialog$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  getIsMonthClicked(): Observable<boolean> {
    return this.isMonthClicked$.asObservable();
  }

  setIsMonthClicked(value: boolean): void {
    this.isMonthClicked$.next(value);
  }

  getCloseDialog(): Observable<boolean> {
    return this.closeDialog$.asObservable();
  }

  setCloseDialog(value: boolean): void {
    this.closeDialog$.next(value);
  }
}
